"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SeatKid = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SeatKid = function SeatKid(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.102 0l2.484 11.181A6.154 6.154 0 008.594 16h3.49v-2.461h-3.49a3.692 3.692 0 01-3.605-2.892L2.623 0H.102zm9.72 3.446a2.462 2.462 0 11-4.922 0 2.462 2.462 0 014.923 0zM6.834 8.678l-.09-.411a1.134 1.134 0 011.109-1.375c.523 0 .969.36 1.066.873.199 1.049.437 1.831 2.203 1.831h.218c.128-.007.268-.011.42-.011 2.223 0 3.231 1.695 3.666 2.893.218.6-.26 1.162-.899 1.162-.54 0-.993-.423-1.258-.894-.292-.52-.854-1.09-1.925-1.177h-.905c-2.268 0-3.13-.565-3.605-2.891z",
    fill: "currentColor"
  }));
};

exports.SeatKid = SeatKid;
var _default = SeatKid;
exports.default = _default;